(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("@fyne/ui", ["react"], factory);
	else if(typeof exports === 'object')
		exports["@fyne/ui"] = factory(require("react"));
	else
		root["@fyne/ui"] = factory(root["React"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_cDcd__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "1yJj");
/******/ })
/************************************************************************/
/******/ ({

/***/ "+4Q3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var types_1 = __webpack_require__("c/c1");

var utils_1 = __webpack_require__("l0/T");

var GET = types_1.HTTPMethod.GET;

function doFetchArgs(initialOptions, method, controller, cacheLife, cache, host, path, routeOrBody, bodyAs2ndParam, requestInterceptor) {
  return __awaiter(this, void 0, void 0, function () {
    var route, url, body, headers, options, responseID, _a, _b;

    var _this = this;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          utils_1.invariant(!(utils_1.isBodyObject(routeOrBody) && utils_1.isBodyObject(bodyAs2ndParam)), "If first argument of " + method.toLowerCase() + "() is an object, you cannot have a 2nd argument. \uD83D\uDE1C");
          utils_1.invariant(!(method === GET && utils_1.isBodyObject(routeOrBody)), 'You can only have query params as 1st argument of request.get()');
          utils_1.invariant(!(method === GET && bodyAs2ndParam !== undefined), 'You can only have query params as 1st argument of request.get()');

          route = function () {
            if (!utils_1.isServer && routeOrBody instanceof URLSearchParams) return "?" + routeOrBody;
            if (utils_1.isString(routeOrBody)) return routeOrBody;
            return '';
          }();

          url = "" + host + utils_1.addSlash(path, host) + utils_1.addSlash(route);

          body = function () {
            // FormData instanceof check should go first, because React Native's FormData implementation
            // is indistinguishable from plain object when using isBodyObject check
            if (routeOrBody instanceof FormData) return routeOrBody;
            if (utils_1.isBodyObject(routeOrBody)) return JSON.stringify(routeOrBody);
            if (!utils_1.isServer && (bodyAs2ndParam instanceof FormData || bodyAs2ndParam instanceof URLSearchParams)) return bodyAs2ndParam;
            if (utils_1.isBodyObject(bodyAs2ndParam) || utils_1.isString(bodyAs2ndParam)) return JSON.stringify(bodyAs2ndParam);
            if (utils_1.isBodyObject(initialOptions.body) || utils_1.isString(bodyAs2ndParam)) return JSON.stringify(initialOptions.body);
            return null;
          }();

          headers = function () {
            var contentType = (initialOptions.headers || {})['Content-Type'];
            var shouldAddContentType = !!contentType || [types_1.HTTPMethod.POST, types_1.HTTPMethod.PUT].includes(method) && !(body instanceof FormData);

            var headers = __assign({}, initialOptions.headers);

            if (shouldAddContentType) {
              // default content types http://bit.ly/2N2ovOZ
              // Accept: 'application/json',
              // roughly, should only add for POST and PUT http://bit.ly/2NJNt3N
              // unless specified by the user
              headers['Content-Type'] = contentType || 'application/json';
            } else if (Object.keys(headers).length === 0) {
              return null;
            }

            return headers;
          }();

          return [4
          /*yield*/
          , function () {
            return __awaiter(_this, void 0, void 0, function () {
              var opts, interceptor;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    opts = __assign(__assign({}, initialOptions), {
                      method: method,
                      signal: controller.signal
                    });

                    if (headers !== null) {
                      opts.headers = headers;
                    } else {
                      delete opts.headers;
                    }

                    if (body !== null) opts.body = body;
                    if (!requestInterceptor) return [3
                    /*break*/
                    , 2];
                    return [4
                    /*yield*/
                    , requestInterceptor({
                      options: opts,
                      url: host,
                      path: path,
                      route: route
                    })];

                  case 1:
                    interceptor = _a.sent();
                    return [2
                    /*return*/
                    , interceptor];

                  case 2:
                    return [2
                    /*return*/
                    , opts];
                }
              });
            });
          }() // TODO: if the body is a file, and this is a large file, it might exceed the size
          // limit of the key size. Potential solution: base64 the body
          // used to tell if a request has already been made
          ];

        case 1:
          options = _c.sent();
          responseID = Object.entries({
            url: url,
            method: method,
            body: options.body || ''
          }).map(function (_a) {
            var key = _a[0],
                value = _a[1];
            return key + ":" + value;
          }).join('||');
          _a = {
            url: url,
            options: options
          };
          _b = {};
          return [4
          /*yield*/
          , cache.has(responseID)];

        case 2:
          _b.isCached = _c.sent(), _b.id = responseID;
          return [4
          /*yield*/
          , cache.get(responseID)];

        case 3:
          return [2
          /*return*/
          , (_a.response = (_b.cached = _c.sent(), _b), _a)];
      }
    });
  });
}

exports["default"] = doFetchArgs;

/***/ }),

/***/ "0Uja":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
var inMemoryStorage = {};

var getMemoryStorage = function getMemoryStorage(_a) {
  var cacheLife = _a.cacheLife;

  var remove = function remove() {
    var responseIDs = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      responseIDs[_i] = arguments[_i];
    }

    return __awaiter(void 0, void 0, void 0, function () {
      var _a, responseIDs_1, responseID;

      return __generator(this, function (_b) {
        for (_a = 0, responseIDs_1 = responseIDs; _a < responseIDs_1.length; _a++) {
          responseID = responseIDs_1[_a];
          delete inMemoryStorage[responseID];
          delete inMemoryStorage[responseID + ":ts"];
        }

        return [2
        /*return*/
        ];
      });
    });
  };

  var isExpired = function isExpired(responseID) {
    var expiration = inMemoryStorage[responseID + ":ts"];
    var expired = expiration > 0 && expiration < Date.now();
    if (expired) remove(responseID);
    return expired || !inMemoryStorage[responseID];
  };

  var get = function get(responseID) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (isExpired(responseID)) return [2
        /*return*/
        ];
        return [2
        /*return*/
        , inMemoryStorage[responseID]];
      });
    });
  };

  var set = function set(responseID, res) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        inMemoryStorage[responseID] = res;
        inMemoryStorage[responseID + ":ts"] = cacheLife > 0 ? Date.now() + cacheLife : 0;
        return [2
        /*return*/
        ];
      });
    });
  };

  var has = function has(responseID) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , !isExpired(responseID)];
      });
    });
  };

  var clear = function clear() {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        inMemoryStorage = {};
        return [2
        /*return*/
        ];
      });
    });
  };

  return Object.defineProperties(inMemoryStorage, {
    get: {
      value: get,
      writable: false,
      configurable: true
    },
    set: {
      value: set,
      writable: false,
      configurable: true
    },
    has: {
      value: has,
      writable: false,
      configurable: true
    },
    "delete": {
      value: remove,
      writable: false,
      configurable: true
    },
    clear: {
      value: clear,
      writable: false,
      configurable: true
    }
  });
};

exports["default"] = getMemoryStorage;

/***/ }),

/***/ "1yJj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "options", function() { return /* binding */ api_options; });
__webpack_require__.d(__webpack_exports__, "url", function() { return /* binding */ api_url; });
__webpack_require__.d(__webpack_exports__, "FyneProvider", function() { return /* binding */ api_FyneProvider; });
__webpack_require__.d(__webpack_exports__, "useFyneAPI", function() { return /* binding */ api_useFyneAPI; });
__webpack_require__.d(__webpack_exports__, "useFyneAPI____USEHTTP", function() { return /* binding */ api_useFyneAPI_USEHTTP; });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("J4zp");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/extends.js
var helpers_extends = __webpack_require__("pVnL");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("o0o1");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("lSNA");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("yXPU");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
var external_root_React_commonjs2_react_commonjs_react_amd_react_ = __webpack_require__("cDcd");
var external_root_React_commonjs2_react_commonjs_react_amd_react_default = /*#__PURE__*/__webpack_require__.n(external_root_React_commonjs2_react_commonjs_react_amd_react_);

// EXTERNAL MODULE: ./node_modules/use-http/dist/index.js
var dist = __webpack_require__("cPIZ");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("cDf5");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// CONCATENATED MODULE: ./node_modules/tslib/tslib.es6.js


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise */
var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};


function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __decorate(decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : typeof_default()(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
}
function __metadata(metadataKey, metadataValue) {
  if ((typeof Reflect === "undefined" ? "undefined" : typeof_default()(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __exportStar(m, exports) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}
function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
}
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
}
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
}
;
function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []),
      i,
      q = [];
  return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
    return this;
  }, i;

  function verb(n) {
    if (g[n]) i[n] = function (v) {
      return new Promise(function (a, b) {
        q.push([n, v, a, b]) > 1 || resume(n, v);
      });
    };
  }

  function resume(n, v) {
    try {
      step(g[n](v));
    } catch (e) {
      settle(q[0][3], e);
    }
  }

  function step(r) {
    r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
  }

  function fulfill(value) {
    resume("next", value);
  }

  function reject(value) {
    resume("throw", value);
  }

  function settle(f, v) {
    if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
  }
}
function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) {
    throw e;
  }), verb("return"), i[Symbol.iterator] = function () {
    return this;
  }, i;

  function verb(n, f) {
    i[n] = o[n] ? function (v) {
      return (p = !p) ? {
        value: __await(o[n](v)),
        done: n === "return"
      } : f ? f(v) : v;
    } : f;
  }
}
function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator],
      i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
    return this;
  }, i);

  function verb(n) {
    i[n] = o[n] && function (v) {
      return new Promise(function (resolve, reject) {
        v = o[n](v), settle(resolve, reject, v.done, v.value);
      });
    };
  }

  function settle(resolve, reject, d, v) {
    Promise.resolve(v).then(function (v) {
      resolve({
        value: v,
        done: d
      });
    }, reject);
  }
}
function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
}
;
function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
}
function __importDefault(mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
}
function __classPrivateFieldGet(receiver, privateMap) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }

  return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to set private field on non-instance");
  }

  privateMap.set(receiver, value);
  return value;
}
// CONCATENATED MODULE: ./node_modules/lower-case/dist.es2015/index.js
/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */
var SUPPORTED_LOCALE = {
  tr: {
    regexp: /\u0130|\u0049|\u0049\u0307/g,
    map: {
      İ: "i",
      I: "\u0131",
      İ: "i"
    }
  },
  az: {
    regexp: /\u0130/g,
    map: {
      İ: "i",
      I: "\u0131",
      İ: "i"
    }
  },
  lt: {
    regexp: /\u0049|\u004A|\u012E|\u00CC|\u00CD|\u0128/g,
    map: {
      I: "i\u0307",
      J: "j\u0307",
      Į: "\u012F\u0307",
      Ì: "i\u0307\u0300",
      Í: "i\u0307\u0301",
      Ĩ: "i\u0307\u0303"
    }
  }
};
/**
 * Localized lower case.
 */

function localeLowerCase(str, locale) {
  var lang = SUPPORTED_LOCALE[locale.toLowerCase()];
  if (lang) return lowerCase(str.replace(lang.regexp, function (m) {
    return lang.map[m];
  }));
  return lowerCase(str);
}
/**
 * Lower case as a function.
 */

function lowerCase(str) {
  return str.toLowerCase();
}
// CONCATENATED MODULE: ./node_modules/no-case/dist.es2015/index.js
 // Support camel case ("camelCase" -> "camel Case" and "CAMELCase" -> "CAMEL Case").

var DEFAULT_SPLIT_REGEXP = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g]; // Remove all non-word characters.

var DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
/**
 * Normalize the string into something other libraries can manipulate easier.
 */

function noCase(input, options) {
  if (options === void 0) {
    options = {};
  }

  var _a = options.splitRegexp,
      splitRegexp = _a === void 0 ? DEFAULT_SPLIT_REGEXP : _a,
      _b = options.stripRegexp,
      stripRegexp = _b === void 0 ? DEFAULT_STRIP_REGEXP : _b,
      _c = options.transform,
      transform = _c === void 0 ? lowerCase : _c,
      _d = options.delimiter,
      delimiter = _d === void 0 ? " " : _d;
  var result = replace(replace(input, splitRegexp, "$1\0$2"), stripRegexp, "\0");
  var start = 0;
  var end = result.length; // Trim the delimiter from around the output string.

  while (result.charAt(start) === "\0") {
    start++;
  }

  while (result.charAt(end - 1) === "\0") {
    end--;
  } // Transform each token independently.


  return result.slice(start, end).split("\0").map(transform).join(delimiter);
}
/**
 * Replace `re` in the input string with the replacement value.
 */

function replace(input, re, value) {
  if (re instanceof RegExp) return input.replace(re, value);
  return re.reduce(function (input, re) {
    return input.replace(re, value);
  }, input);
}
// CONCATENATED MODULE: ./node_modules/pascal-case/dist.es2015/index.js


function pascalCaseTransform(input, index) {
  var firstChar = input.charAt(0);
  var lowerChars = input.substr(1).toLowerCase();

  if (index > 0 && firstChar >= "0" && firstChar <= "9") {
    return "_" + firstChar + lowerChars;
  }

  return "" + firstChar.toUpperCase() + lowerChars;
}
function pascalCaseTransformMerge(input) {
  return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
}
function pascalCase(input, options) {
  if (options === void 0) {
    options = {};
  }

  return noCase(input, _assign({
    delimiter: "",
    transform: pascalCaseTransform
  }, options));
}
// CONCATENATED MODULE: ./node_modules/camel-case/dist.es2015/index.js


function camelCaseTransform(input, index) {
  if (index === 0) return input.toLowerCase();
  return pascalCaseTransform(input, index);
}
function camelCaseTransformMerge(input, index) {
  if (index === 0) return input.toLowerCase();
  return pascalCaseTransformMerge(input);
}
function camelCase(input, options) {
  if (options === void 0) {
    options = {};
  }

  return pascalCase(input, _assign({
    transform: camelCaseTransform
  }, options));
}
// CONCATENATED MODULE: ./node_modules/dot-case/dist.es2015/index.js


function dotCase(input, options) {
  if (options === void 0) {
    options = {};
  }

  return noCase(input, _assign({
    delimiter: "."
  }, options));
}
// CONCATENATED MODULE: ./node_modules/param-case/dist.es2015/index.js


function paramCase(input, options) {
  if (options === void 0) {
    options = {};
  }

  return dotCase(input, _assign({
    delimiter: "-"
  }, options));
}
// EXTERNAL MODULE: ./src/helpers/currentScript-IE9-11.js
var currentScript_IE9_11 = __webpack_require__("LpkI");

// EXTERNAL MODULE: ./src/helpers/currentScript-IE6-10.js
var currentScript_IE6_10 = __webpack_require__("BhS4");

// CONCATENATED MODULE: ./src/helpers/currentScript.js
// first try to pollyfill for IE11
 // first try to pollyfill for IE8 or less

 // https://stackoverflow.com/questions/403967/how-may-i-reference-the-script-tag-that-loaded-the-currently-executing-script

var script = function () {
  var cs = document.currentScript;

  if (!cs) {
    // find by pollyfill or dom query
    cs = !cs && document._currentScript && document._currentScript(); // don't do this, would break if these props change
    //cs = !cs && document.getElementById('fwxfrm-script');
    //cs = !cs && document.querySelector('script[data-name="fwxfrm"]');
  }

  if (!cs) {
    // assume last script
    var scripts = document.getElementsByTagName("script");
    cs = scripts[scripts.length - 1];
  }

  var _cs = cs,
      baseURI = _cs.baseURI,
      src = _cs.src;
  var cur_path = baseURI;
  var src_path = src && src.match(/^(https?\:\/\/[^\/]+\/)/gi)[0]; //console.log('current script:', {cs,baseURI,src,cur_path,src_path});

  return {
    src_path: src_path,
    cur_path: cur_path,
    src: src,
    tag: cs
  };
}();
// CONCATENATED MODULE: ./src/context.js
//import React from 'react';

 //console.log('FYNEWORKS CONTEXT', {a:process.env.PATH,b:script.src_path,s:script,env:process.env})
//console.log('FYNEWORKS CONTEXT process.env.PATH', process.env.PATH)
//console.log('FYNEWORKS CONTEXT script.src_path', script.src_path)
//console.log('FYNEWORKS CONTEXT process.env', process.env)

var APP_BASE = script.src_path || {"REACT_APP_FWX_SELF":"https://ui.fyneworks.io/","REACT_APP_FWX_MODE":"production","NODE_ENV":"production"}.PATH || './';
var EnvironmentConstants = function EnvironmentConstants() {
  var x = /^(REACT_APP_)?(FWX_)/gi;
  var o = {
    APP_BASE: APP_BASE
  };
  var i = Object.assign({}, {"REACT_APP_FWX_SELF":"https://ui.fyneworks.io/","REACT_APP_FWX_MODE":"production","NODE_ENV":"production"});
  var k = Object.keys(i).filter(function (n) {
    return n.match(x);
  });
  k.forEach(function (n) {
    o[n.replace(x, 'FWX_').toUpperCase()] = i[n];
  });
  return o;
};
var environment = function environment(n) {
  var u = n.replace(/\s+/gi, '_').toUpperCase(); //const l = n.replace(/\s+/gi,'_').toLowerCase();
  ////console.log('Fyneworks config constant', u, l);

  return {"REACT_APP_FWX_SELF":"https://ui.fyneworks.io/","REACT_APP_FWX_MODE":"production","NODE_ENV":"production"}['REACT_APP_FWX_' + u] || {"REACT_APP_FWX_SELF":"https://ui.fyneworks.io/","REACT_APP_FWX_MODE":"production","NODE_ENV":"production"}['FWX_' + u]; // see https://create-react-app.dev/docs/adding-custom-environment-variables/
};
var constant = function constant(n) {
  var dataset = function dataset() {
    return Object.assign({}, document.body.dataset);
  };

  var u = n.replace(/\s+/gi, '_').toUpperCase();
  var l = n.replace(/\s+/gi, '_').toLowerCase(); ////console.log('Fyneworks config constant', u, l);

  return {"REACT_APP_FWX_SELF":"https://ui.fyneworks.io/","REACT_APP_FWX_MODE":"production","NODE_ENV":"production"}['REACT_APP_FWX_' + u] || {"REACT_APP_FWX_SELF":"https://ui.fyneworks.io/","REACT_APP_FWX_MODE":"production","NODE_ENV":"production"}['FWX_' + u] || window['FWX_' + u] || dataset[l]; // see https://create-react-app.dev/docs/adding-custom-environment-variables/
};
var context_setting = function setting(n) {
  var fwx = Object.assign({}, window.fwx || {}, window.FWX || {});
  var u = n.replace(/\s+/gi, '_').toUpperCase();
  var l = n.replace(/\s+/gi, '_').toLowerCase();
  var c = camelCase(n.replace(/_+/gi, ' ')); ////console.log('Fyneworks config setting', u, l, c);

  return fwx[u] || fwx[c] || fwx[l];
};
var context_scriptProp = function scriptProp(n) {
  var dataset = function dataset() {
    return Object.assign({}, document.body.dataset);
  };

  var c = camelCase(n.replace(/[-\s+]/gi, '_'));
  var p = paramCase(n.replace(/[-\s+]/gi, '_')); ////console.log('Fyneworks config constant', u, l, d);

  return dataset && dataset[c] && dataset[p]; // see https://create-react-app.dev/docs/adding-custom-environment-variables/
}; ////console.log('Fyneworks config EnvironmentConstants()', EnvironmentConstants())

var ParseContext = function ParseContext(defaults, overrides) {
  //console.log('ParseContext invoked');
  var context = Object.assign({}, // inline defaults
  defaults || {}, // expose all environment vars if needed
  EnvironmentConstants(), //{ env:Environment() },
  // run-time defaults
  {
    edition: context_scriptProp('edition') || constant('edition') || context_setting('edition') || window['EDITION'],
    timezone: context_scriptProp('timezone') || constant('timezone') || context_setting('timezone'),
    //  window['FWX_TIMEZONE'] || dataset.timezone,
    license: context_scriptProp('license') || constant('license') || context_setting('license'),
    domain: context_scriptProp('domain') || constant('domain') || context_setting('domain'),
    //  window['FWX_DOMAIN'] || dataset.domain,
    base: context_scriptProp('base') || constant('base') || context_setting('base'),
    path: context_scriptProp('API_PATH') || constant('API_PATH') || context_setting('API_PATH') || '/api',
    cur: context_scriptProp('cur') || constant('cur') || context_setting('cur'),
    //  window['FWX_CUR'] || dataset.cur,
    cursym: context_scriptProp('cursym') || constant('cursym') || context_setting('cursym'),
    //  window['FWX_CURSYM'] || dataset.cursym,
    curdec: context_scriptProp('curdec') || constant('curdec') || context_setting('curdec') //  window['FWX_CURDEC'] || dataset.curdec,

  }, // core config
  window.fwx && (window.fwx.config || {}), // site config
  window.FWX || {}, // accept runtime overrides
  overrides || {});

  if (!context.base) {
    if (context.domain) {
      context.base = 'https://' + context.domain;
    }
  }

  if (!context.base) {
    context.base = document.location.origin;
  }

  context.API_BASE = context.base + '' + context.path; // + '/';

  return context;
};
var context = ParseContext();
/* harmony default export */ var src_context = (context); //console.log('FYNEWORKS CONTEXT RESULT (processed process.env and others)', context);
//export const FyneContext = React.createContext(context);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("QILm");
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties);

// CONCATENATED MODULE: ./node_modules/whatwg-fetch/fetch.js
var support = {
  searchParams: 'URLSearchParams' in self,
  iterable: 'Symbol' in self && 'iterator' in Symbol,
  blob: 'FileReader' in self && 'Blob' in self && function () {
    try {
      new Blob();
      return true;
    } catch (e) {
      return false;
    }
  }(),
  formData: 'FormData' in self,
  arrayBuffer: 'ArrayBuffer' in self
};

function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj);
}

if (support.arrayBuffer) {
  var viewClasses = ['[object Int8Array]', '[object Uint8Array]', '[object Uint8ClampedArray]', '[object Int16Array]', '[object Uint16Array]', '[object Int32Array]', '[object Uint32Array]', '[object Float32Array]', '[object Float64Array]'];

  var isArrayBufferView = ArrayBuffer.isView || function (obj) {
    return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
  };
}

function normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name);
  }

  if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
    throw new TypeError('Invalid character in header field name');
  }

  return name.toLowerCase();
}

function normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value);
  }

  return value;
} // Build a destructive iterator for the value list


function iteratorFor(items) {
  var iterator = {
    next: function next() {
      var value = items.shift();
      return {
        done: value === undefined,
        value: value
      };
    }
  };

  if (support.iterable) {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }

  return iterator;
}

function Headers(headers) {
  this.map = {};

  if (headers instanceof Headers) {
    headers.forEach(function (value, name) {
      this.append(name, value);
    }, this);
  } else if (Array.isArray(headers)) {
    headers.forEach(function (header) {
      this.append(header[0], header[1]);
    }, this);
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function (name) {
      this.append(name, headers[name]);
    }, this);
  }
}

Headers.prototype.append = function (name, value) {
  name = normalizeName(name);
  value = normalizeValue(value);
  var oldValue = this.map[name];
  this.map[name] = oldValue ? oldValue + ', ' + value : value;
};

Headers.prototype['delete'] = function (name) {
  delete this.map[normalizeName(name)];
};

Headers.prototype.get = function (name) {
  name = normalizeName(name);
  return this.has(name) ? this.map[name] : null;
};

Headers.prototype.has = function (name) {
  return this.map.hasOwnProperty(normalizeName(name));
};

Headers.prototype.set = function (name, value) {
  this.map[normalizeName(name)] = normalizeValue(value);
};

Headers.prototype.forEach = function (callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this);
    }
  }
};

Headers.prototype.keys = function () {
  var items = [];
  this.forEach(function (value, name) {
    items.push(name);
  });
  return iteratorFor(items);
};

Headers.prototype.values = function () {
  var items = [];
  this.forEach(function (value) {
    items.push(value);
  });
  return iteratorFor(items);
};

Headers.prototype.entries = function () {
  var items = [];
  this.forEach(function (value, name) {
    items.push([name, value]);
  });
  return iteratorFor(items);
};

if (support.iterable) {
  Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
}

function consumed(body) {
  if (body.bodyUsed) {
    return Promise.reject(new TypeError('Already read'));
  }

  body.bodyUsed = true;
}

function fileReaderReady(reader) {
  return new Promise(function (resolve, reject) {
    reader.onload = function () {
      resolve(reader.result);
    };

    reader.onerror = function () {
      reject(reader.error);
    };
  });
}

function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader();
  var promise = fileReaderReady(reader);
  reader.readAsArrayBuffer(blob);
  return promise;
}

function readBlobAsText(blob) {
  var reader = new FileReader();
  var promise = fileReaderReady(reader);
  reader.readAsText(blob);
  return promise;
}

function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf);
  var chars = new Array(view.length);

  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i]);
  }

  return chars.join('');
}

function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0);
  } else {
    var view = new Uint8Array(buf.byteLength);
    view.set(new Uint8Array(buf));
    return view.buffer;
  }
}

function Body() {
  this.bodyUsed = false;

  this._initBody = function (body) {
    this._bodyInit = body;

    if (!body) {
      this._bodyText = '';
    } else if (typeof body === 'string') {
      this._bodyText = body;
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body;
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body;
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString();
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer); // IE 10-11 can't handle a DataView body.

      this._bodyInit = new Blob([this._bodyArrayBuffer]);
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body);
    } else {
      this._bodyText = body = Object.prototype.toString.call(body);
    }

    if (!this.headers.get('content-type')) {
      if (typeof body === 'string') {
        this.headers.set('content-type', 'text/plain;charset=UTF-8');
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set('content-type', this._bodyBlob.type);
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
      }
    }
  };

  if (support.blob) {
    this.blob = function () {
      var rejected = consumed(this);

      if (rejected) {
        return rejected;
      }

      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as blob');
      } else {
        return Promise.resolve(new Blob([this._bodyText]));
      }
    };

    this.arrayBuffer = function () {
      if (this._bodyArrayBuffer) {
        return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
      } else {
        return this.blob().then(readBlobAsArrayBuffer);
      }
    };
  }

  this.text = function () {
    var rejected = consumed(this);

    if (rejected) {
      return rejected;
    }

    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob);
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
    } else if (this._bodyFormData) {
      throw new Error('could not read FormData body as text');
    } else {
      return Promise.resolve(this._bodyText);
    }
  };

  if (support.formData) {
    this.formData = function () {
      return this.text().then(decode);
    };
  }

  this.json = function () {
    return this.text().then(JSON.parse);
  };

  return this;
} // HTTP methods whose capitalization should be normalized


var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

function normalizeMethod(method) {
  var upcased = method.toUpperCase();
  return methods.indexOf(upcased) > -1 ? upcased : method;
}

function Request(input, options) {
  options = options || {};
  var body = options.body;

  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError('Already read');
    }

    this.url = input.url;
    this.credentials = input.credentials;

    if (!options.headers) {
      this.headers = new Headers(input.headers);
    }

    this.method = input.method;
    this.mode = input.mode;
    this.signal = input.signal;

    if (!body && input._bodyInit != null) {
      body = input._bodyInit;
      input.bodyUsed = true;
    }
  } else {
    this.url = String(input);
  }

  this.credentials = options.credentials || this.credentials || 'same-origin';

  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers);
  }

  this.method = normalizeMethod(options.method || this.method || 'GET');
  this.mode = options.mode || this.mode || null;
  this.signal = options.signal || this.signal;
  this.referrer = null;

  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    throw new TypeError('Body not allowed for GET or HEAD requests');
  }

  this._initBody(body);
}

Request.prototype.clone = function () {
  return new Request(this, {
    body: this._bodyInit
  });
};

function decode(body) {
  var form = new FormData();
  body.trim().split('&').forEach(function (bytes) {
    if (bytes) {
      var split = bytes.split('=');
      var name = split.shift().replace(/\+/g, ' ');
      var value = split.join('=').replace(/\+/g, ' ');
      form.append(decodeURIComponent(name), decodeURIComponent(value));
    }
  });
  return form;
}

function parseHeaders(rawHeaders) {
  var headers = new Headers(); // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2

  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
  preProcessedHeaders.split(/\r?\n/).forEach(function (line) {
    var parts = line.split(':');
    var key = parts.shift().trim();

    if (key) {
      var value = parts.join(':').trim();
      headers.append(key, value);
    }
  });
  return headers;
}

Body.call(Request.prototype);
function Response(bodyInit, options) {
  if (!options) {
    options = {};
  }

  this.type = 'default';
  this.status = options.status === undefined ? 200 : options.status;
  this.ok = this.status >= 200 && this.status < 300;
  this.statusText = 'statusText' in options ? options.statusText : 'OK';
  this.headers = new Headers(options.headers);
  this.url = options.url || '';

  this._initBody(bodyInit);
}
Body.call(Response.prototype);

Response.prototype.clone = function () {
  return new Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new Headers(this.headers),
    url: this.url
  });
};

Response.error = function () {
  var response = new Response(null, {
    status: 0,
    statusText: ''
  });
  response.type = 'error';
  return response;
};

var redirectStatuses = [301, 302, 303, 307, 308];

Response.redirect = function (url, status) {
  if (redirectStatuses.indexOf(status) === -1) {
    throw new RangeError('Invalid status code');
  }

  return new Response(null, {
    status: status,
    headers: {
      location: url
    }
  });
};

var DOMException = self.DOMException;

try {
  new DOMException();
} catch (err) {
  DOMException = function DOMException(message, name) {
    this.message = message;
    this.name = name;
    var error = Error(message);
    this.stack = error.stack;
  };

  DOMException.prototype = Object.create(Error.prototype);
  DOMException.prototype.constructor = DOMException;
}

function fetch_fetch(input, init) {
  return new Promise(function (resolve, reject) {
    var request = new Request(input, init);

    if (request.signal && request.signal.aborted) {
      return reject(new DOMException('Aborted', 'AbortError'));
    }

    var xhr = new XMLHttpRequest();

    function abortXhr() {
      xhr.abort();
    }

    xhr.onload = function () {
      var options = {
        status: xhr.status,
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
      };
      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
      var body = 'response' in xhr ? xhr.response : xhr.responseText;
      resolve(new Response(body, options));
    };

    xhr.onerror = function () {
      reject(new TypeError('Network request failed'));
    };

    xhr.ontimeout = function () {
      reject(new TypeError('Network request failed'));
    };

    xhr.onabort = function () {
      reject(new DOMException('Aborted', 'AbortError'));
    };

    xhr.open(request.method, request.url, true);

    if (request.credentials === 'include') {
      xhr.withCredentials = true;
    } else if (request.credentials === 'omit') {
      xhr.withCredentials = false;
    }

    if ('responseType' in xhr && support.blob) {
      xhr.responseType = 'blob';
    }

    request.headers.forEach(function (value, name) {
      xhr.setRequestHeader(name, value);
    });

    if (request.signal) {
      request.signal.addEventListener('abort', abortXhr);

      xhr.onreadystatechange = function () {
        // DONE (success or failure)
        if (xhr.readyState === 4) {
          request.signal.removeEventListener('abort', abortXhr);
        }
      };
    }

    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
  });
}
fetch_fetch.polyfill = true;

if (!self.fetch) {
  self.fetch = fetch_fetch;
  self.Headers = Headers;
  self.Request = Request;
  self.Response = Response;
}
// CONCATENATED MODULE: ./src/network.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// fetch polyfill
// https://github.com/github/fetch


var GET = "get";
var PUT = "put";
var POST = "post";
var DEL = "delete";
var PATCH = "patch";
var METHODS = [GET, PUT, POST, DEL, PATCH];
var serialize = function serialize(obj) {
  var str = [];

  for (var p in obj) {
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  }

  return str.join("&");
};
var signature = function signature(_ref) {
  var license = _ref.license,
      domain = _ref.domain,
      method = _ref.method,
      url = _ref.url;
  return ''; //signature will go here';
};
var network_headers = function headers(_ref2) {
  var method = _ref2.method,
      url = _ref2.url;
  var license = context.license,
      domain = context.domain;
  return {
    "Content-Type": "application/json",
    license: license,
    //domain,
    signature: signature({
      license: license,
      domain: domain,
      method: method,
      url: url
    })
  };
};
var network_request = function request(url, _ref3) {
  var _ref3$method = _ref3.method,
      method = _ref3$method === void 0 ? GET : _ref3$method,
      _ref3$body = _ref3.body,
      body = _ref3$body === void 0 ? null : _ref3$body,
      _ref3$query = _ref3.query,
      query = _ref3$query === void 0 ? {} : _ref3$query,
      options = objectWithoutProperties_default()(_ref3, ["method", "body", "query"]);

  //console.log('Fyne request', {url, method, body, options});
  return new Promise(function (resolve, reject) {
    var queryStr = query && serialize(query);
    var endpoint = query ? url + '?' + queryStr : url; //console.log('Fyne request fetch', {url, method, body, options, queryStr, endpoint});

    fetch(endpoint, _objectSpread(_objectSpread({
      method: method
    }, method === GET ? {} : {
      body: JSON.stringify(body)
    }), {}, {
      headers: _objectSpread(_objectSpread({}, network_headers({
        method: method,
        url: url
      })), options.headers || {})
    }, options)).then(function (res) {
      return res.json();
    }).then(function (res) {
      //console.log('Fyne request resp!', res, {url, method, body, options, queryStr, endpoint});
      resolve(res); //({ status:200,success:true,error:null});
    })["catch"](function (err) {
      console.error('Fyne request fail!', err);
      reject(err); //({ status:200,success:true,error:null});
    });
  });
};

var _get = function get(url, _ref4) {
  var props = extends_default()({}, _ref4);

  return network_request(url, _objectSpread({
    method: GET
  }, props));
};



var _put = function put(url, _ref5) {
  var props = extends_default()({}, _ref5);

  return network_request(url, _objectSpread({
    method: PUT
  }, props));
};



var _post = function post(url, _ref6) {
  var props = extends_default()({}, _ref6);

  return network_request(url, _objectSpread({
    method: POST
  }, props));
};



var _del = function del(url, _ref7) {
  var props = extends_default()({}, _ref7);

  return network_request(url, _objectSpread({
    method: DEL
  }, props));
};



var _patch = function patch(url, _ref8) {
  var props = extends_default()({}, _ref8);

  return network_request(url, _objectSpread({
    method: PATCH
  }, props));
};


var network_Endpoint = function Endpoint(url) {
  return {
    get: function get(_ref9) {
      var props = extends_default()({}, _ref9);

      return _get(url, props);
    },
    put: function put(_ref10) {
      var props = extends_default()({}, _ref10);

      return _put(url, props);
    },
    post: function post(_ref11) {
      var props = extends_default()({}, _ref11);

      return _post(url, props);
    },
    del: function del(_ref12) {
      var props = extends_default()({}, _ref12);

      return _del(url, props);
    },
    patch: function patch(_ref13) {
      var props = extends_default()({}, _ref13);

      return _patch(url, props);
    }
  };
};
// CONCATENATED MODULE: ./src/api.js






function api_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function api_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { api_ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { api_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

 //const React = require('react');
//import { useState, useCallback, useEffect } from 'react';

var useState = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.useState; //import { useState } from 'react';

var useEffect = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.useEffect; //import { useEffect } from 'react';

var useCallback = external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.useCallback; //import { useCallback } from 'react';




var api_options = {
  cachePolicy: 'no-cache',
  interceptors: {
    // every time we make an http request, this will run 1st before the request is made
    // url, path and route are supplied to the interceptor
    // request options can be modified and must be returned
    request: function () {
      var _request = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref) {
        var options, url, path, route;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _ref.options, url = _ref.url, path = _ref.path, route = _ref.route;
                //console.log('Fyneworks API intercepted request', { options, url, path, route });
                //if (isExpired(token)) {
                //    token = await getNewToken()
                //    setToken(token)
                //}
                //options.headers.Authorization = `Bearer ${token}`
                options.headers = api_objectSpread(api_objectSpread({}, network_headers({
                  url: url,
                  method: options.method
                })), options.headers);
                return _context.abrupt("return", options);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function request(_x) {
        return _request.apply(this, arguments);
      }

      return request;
    }(),
    // every time we make an http request, before getting the response back, this will run
    response: function () {
      var _response2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(_ref2) {
        var _response, res;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _response = _ref2.response;
                //console.log('Fyneworks API intercepted response', { response });
                res = _response; //if (res.data){
                //    setData(res.data.data)
                //}

                return _context2.abrupt("return", res);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function response(_x2) {
        return _response2.apply(this, arguments);
      }

      return response;
    }()
  }
};
var api_url = context.API_BASE;
var api_FyneProvider = function FyneProvider(_ref3) {
  var props = extends_default()({}, _ref3);

  //console.log('FyneProvider INIT', props);
  return /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default.a.createElement(dist["Provider"], {
    url: api_url,
    options: api_options
  }, props.children);
};
var api_useFyneAPI = function useFyneAPI(func) {
  var dependencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var baseUrl = context.API_BASE + func; //console.log('useFyneAPI', { func, dependencies });

  var _useState = useState(false),
      _useState2 = slicedToArray_default()(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = slicedToArray_default()(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var run = useCallback(function (options) {
    setError(false);
    setLoading(true);
    var method = options.method || GET;
    var endpoint = network_Endpoint(baseUrl);
    var request = endpoint[method]; //console.log('useFyneAPI run', {method, options, baseUrl, endpoint, request});

    return new Promise(function (resolve, reject) {
      return request(options).then(function (res) {
        return res.json();
      }).then(function (res) {
        setLoading(false);

        if (res.status == 'y') {
          resolve({
            data: res.data,
            status: res.status
          });
        } else {
          setError(true);
          reject({
            data: res.data,
            status: res.status
          });
        }
      })["catch"](function (err) {
        setLoading(false);
        setError(true);
        reject({
          data: [],
          status: 'n'
        });
      });
    });
  }, [loading, error]);

  var get = function get(query) {
    return run({
      method: GET,
      query: query
    });
  };

  var post = function post(body) {
    return run({
      method: PUT,
      body: body
    });
  };

  var put = function put(body) {
    return run({
      method: POST,
      body: body
    });
  };

  var del = function del(body) {
    return run({
      method: DEL,
      body: body
    });
  };

  var patch = function patch(body) {
    return run({
      method: PATCH,
      body: body
    });
  };

  useEffect(function () {
    get();
  }, dependencies);
  return {
    run: run,
    get: get,
    post: post,
    put: put,
    del: del,
    patch: patch,
    error: error,
    loading: loading
  };
};
var api_useFyneAPI_USEHTTP = function useFyneAPI____USEHTTP(func, dependencies) {
  //const [ data, setData ] = useState({});
  var url = context.API_BASE + func; //console.log('useFyneAPI', { func, dependencies });

  var _useFetch = dist_default()( // the url of the request
  url, // these hold the interceptors to sign the request
  api_options, // if this is [] the request fires immediately
  // if this is undefined requests need to be invoked
  dependencies),
      request = _useFetch.request,
      response = _useFetch.response,
      loading = _useFetch.loading,
      error = _useFetch.error,
      rawData = _useFetch.data,
      cache = _useFetch.cache,
      get = _useFetch.get,
      post = _useFetch.post,
      put = _useFetch.put,
      patch = _useFetch.patch,
      del = _useFetch.del,
      mutate = _useFetch.mutate,
      query = _useFetch.query,
      abort = _useFetch.abort;

  var data = rawData && rawData.data; // want to use object destructuring? You can do that too

  return {
    request: request,
    response: response,
    // � Do not destructure the `response` object!
    loading: loading,
    error: error,
    data: data,
    cache: cache,
    // .has(), .clear(), .delete(), .get(), .set()    (similar to JS Map)
    get: get,
    post: post,
    put: put,
    patch: patch,
    del: del,
    // `delete` is a keyword
    mutate: mutate,
    // GraphQL
    query: query,
    // GraphQL
    abort: abort
  };
};

/***/ }),

/***/ "8OQS":
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),

/***/ "99zy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _1 = __importStar(__webpack_require__("cPIZ"));

var react_1 = __webpack_require__("cDcd");

var utils_1 = __webpack_require__("l0/T");

exports.useQuery = function (urlOrQuery, queryArg) {
  var context = react_1.useContext(_1.FetchContext);
  utils_1.useURLRequiredInvariant(!!context.url && Array.isArray(urlOrQuery), 'useQuery');
  utils_1.useURLRequiredInvariant(!!context.url || utils_1.isString(urlOrQuery) && !queryArg, 'useQuery', 'OR you need to do useQuery("https://example.com", `your graphql query`)'); // regular no context: useQuery('https://example.com', `graphql QUERY`)

  var url = urlOrQuery;
  var QUERY = queryArg; // tagged template literal with context: useQuery`graphql QUERY`

  if (Array.isArray(urlOrQuery) && context.url) {
    utils_1.invariant(!queryArg, 'You cannot have a 2nd argument when using tagged template literal syntax with useQuery.');
    url = context.url;
    QUERY = urlOrQuery[0]; // regular with context: useQuery(`graphql QUERY`)
  } else if (urlOrQuery && !queryArg && context.url) {
    url = context.url;
    QUERY = urlOrQuery;
  }

  var _a = _1["default"](url),
      loading = _a.loading,
      error = _a.error,
      cache = _a.cache,
      request = __rest(_a, ["loading", "error", "cache"]);

  var query = react_1.useCallback(function (variables) {
    return request.query(QUERY, variables);
  }, [QUERY, request]);
  var data = (request.data || {
    data: undefined
  }).data;
  return Object.assign([data, loading, error, query], {
    data: data,
    loading: loading,
    error: error,
    query: query,
    cache: cache
  });
};

/***/ }),

/***/ "Bapv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _1 = __importStar(__webpack_require__("cPIZ"));

var react_1 = __webpack_require__("cDcd");

var utils_1 = __webpack_require__("l0/T");

exports.useMutation = function (urlOrMutation, mutationArg) {
  var context = react_1.useContext(_1.FetchContext);
  utils_1.useURLRequiredInvariant(!!context.url && Array.isArray(urlOrMutation), 'useMutation');
  utils_1.useURLRequiredInvariant(!!context.url || utils_1.isString(urlOrMutation) && !mutationArg, 'useMutation', 'OR you need to do useMutation("https://example.com", `your graphql mutation`)'); // regular no context: useMutation('https://example.com', `graphql MUTATION`)

  var url = urlOrMutation;
  var MUTATION = mutationArg; // tagged template literal with context: useMutation`graphql MUTATION`

  if (Array.isArray(urlOrMutation) && context.url) {
    utils_1.invariant(!mutationArg, 'You cannot have a 2nd argument when using tagged template literal syntax with useMutation.');
    url = context.url;
    MUTATION = urlOrMutation[0]; // regular with context: useMutation(`graphql MUTATION`)
  } else if (urlOrMutation && !mutationArg && context.url) {
    url = context.url;
    MUTATION = urlOrMutation;
  }

  var _a = _1["default"](url),
      loading = _a.loading,
      error = _a.error,
      cache = _a.cache,
      request = __rest(_a, ["loading", "error", "cache"]);

  var mutate = react_1.useCallback(function (inputs) {
    return request.mutate(MUTATION, inputs);
  }, [MUTATION, request]);
  var data = (request.data || {
    data: undefined
  }).data;
  return Object.assign([data, loading, error, mutate], {
    data: data,
    loading: loading,
    error: error,
    mutate: mutate,
    cache: cache
  });
};

/***/ }),

/***/ "BhS4":
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__("cDf5");

// https://github.com/JamesMGreene/document.currentScript

/*!
 * document.currentScript
 * Polyfill for `document.currentScript`.
 * Copyright (c) 2016 James M. Greene
 * Licensed MIT
 * https://github.com/JamesMGreene/document.currentScript
 * v1.1.0
 */
(function () {
  // Live NodeList collection
  var scripts = document.getElementsByTagName("script"); // Check if the browser supports the `readyState` property on `script` elements

  var supportsScriptReadyState = ("readyState" in (scripts[0] || document.createElement("script"))); // Lousy browser detection for [not] Opera

  var isNotOpera = !window.opera || window.opera.toString() !== "[object Opera]"; // Guaranteed accurate in IE 6-10.
  // Not supported in any other browsers. =(

  var canPolyfill = supportsScriptReadyState && isNotOpera; // Attempt to retrieve the native `document.currentScript` accessor method

  var nativeCurrentScriptFn = function (doc) {
    /*jshint proto:true */
    var hasNativeMethod = ("currentScript" in doc);
    var canGetDescriptor = typeof Object.getOwnPropertyDescriptor === "function";
    var canGetPrototype = typeof Object.getPrototypeOf === "function";
    var canUseDunderProto = _typeof("test".__proto__) === "object";

    function _invokeNativeCurrentScriptMethod() {
      var des,
          csFnIsNotOurs = true;

      if (canGetDescriptor) {
        des = Object.getOwnPropertyDescriptor(doc, "currentScript") || undefined;

        if (des && typeof des.get === "function" && des.get === _currentEvaluatingScript) {
          csFnIsNotOurs = false;
        }
      } // Potentially dangerous hack...


      return csFnIsNotOurs ? doc.currentScript : null;
    }

    function _getProto(obj) {
      var proto;

      if (obj != null) {
        proto = canGetPrototype ? Object.getPrototypeOf(obj) : canUseDunderProto ? obj.__proto__ : obj.constructor != null ? obj.constructor.prototype : undefined;
      }

      return proto;
    }

    var nativeFn = function _getCurrentScriptDef(docSelfOrAncestor, doc) {
      var des, cs;

      if (hasNativeMethod && canGetDescriptor && docSelfOrAncestor && docSelfOrAncestor !== Object.prototype && doc && doc !== Object.prototype) {
        if (canGetDescriptor) {
          des = Object.getOwnPropertyDescriptor(docSelfOrAncestor, "currentScript") || undefined;

          if (des && typeof des.get === "function") {
            cs = des.get;
          }
        }

        if (!cs) {
          cs = _getCurrentScriptDef(_getProto(docSelfOrAncestor), doc);
        }
      }

      if (!cs) {
        cs = _invokeNativeCurrentScriptMethod;
      } else if (cs === _currentEvaluatingScript) {
        cs = undefined;
      }

      return cs;
    }(doc, doc);

    return nativeFn;
  }(document); // Top-level API (compliant with `document.currentScript` specifications)
  //
  // Get the currently "executing" (i.e. EVALUATING) `script` DOM
  // element, per the spec requirements for `document.currentScript`.
  //
  // IMPORTANT: This polyfill CANNOT achieve 100% accurate results
  //            cross-browser. ;_;


  function _currentEvaluatingScript() {
    // Yes, this IS possible, i.e. if a script removes other scripts (or itself)
    if (scripts.length === 0) {
      return null;
    } // Guaranteed accurate in IE 6-10.
    // Not supported in any other browsers. =(


    if (canPolyfill) {
      for (var i = scripts.length; i--;) {
        if (scripts[i] && scripts[i].readyState === "interactive") {
          return scripts[i];
        }
      }
    } // If the native method exists, defer to that as a last-ditch effort


    if (typeof nativeCurrentScriptFn === "function" && _currentEvaluatingScript.doNotDeferToNativeMethod !== true) {
      return nativeCurrentScriptFn.call(document) || null;
    } // Any other attempts cannot be guaranteed and, as such, should be left out
    // from this "Strict Mode" behavior.
    // Alas, returning `null` here is not necessarily accurate either.
    // We could return `undefined` instead but that would not comply with the spec
    // in cases where it should correctly be returning `null`.


    return null;
  } // Allow a last-ditch effort to use the native `document.currentScript` accessor
  // method (if it exists and can be retrieved)?


  _currentEvaluatingScript.doNotDeferToNativeMethod = false; // Inspect the polyfill-ability of this browser

  var needsPolyfill = !("currentScript" in document);

  var canDefineProp = typeof Object.defineProperty === "function" && function () {
    var result;

    try {
      Object.defineProperty(document, "_xyz", {
        get: function get() {
          return "blah";
        },
        configurable: true
      });
      result = document._xyz === "blah";
      delete document._xyz;
    } catch (e) {
      result = false;
    }

    return result;
  }(); // Add the "private" property for testing, even if the real property can be polyfilled


  document._currentScript = _currentEvaluatingScript; // Polyfill it!

  if (needsPolyfill && canDefineProp && typeof canPolyfill !== "undefined" && canPolyfill) {
    Object.defineProperty(document, "currentScript", {
      get: _currentEvaluatingScript
    });
  }
})();

/***/ }),

/***/ "DSXY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var types_1 = __webpack_require__("c/c1");

var utils_1 = __webpack_require__("l0/T");

exports.useFetchArgsDefaults = {
  host: '',
  path: undefined,
  customOptions: {
    cacheLife: 0,
    cachePolicy: types_1.CachePolicies.CACHE_FIRST,
    interceptors: {},
    onAbort: function onAbort() {},
    onError: function onError() {},
    onNewData: function onNewData(currData, newData) {
      return newData;
    },
    onTimeout: function onTimeout() {},
    perPage: 0,
    persist: false,
    responseType: ['json', 'text', 'blob', 'arrayBuffer'],
    retries: 0,
    retryDelay: 1000,
    retryOn: [],
    suspense: false,
    timeout: 0,
    // defaults
    data: undefined,
    loading: false
  },
  requestInit: {
    headers: {
      Accept: 'application/json, text/plain, */*'
    }
  },
  dependencies: undefined
};
exports["default"] = Object.entries(exports.useFetchArgsDefaults).reduce(function (acc, _a) {
  var _b;

  var key = _a[0],
      value = _a[1];
  if (utils_1.isObject(value)) return __assign(__assign({}, acc), value);
  return __assign(__assign({}, acc), (_b = {}, _b[key] = value, _b));
}, {});

/***/ }),

/***/ "GoE2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__("J4zp");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __webpack_require__("cDcd");
/**
 * Determines if the given param is an object. {}
 * @param obj
 */


exports.isObject = function (obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}; // eslint-disable-line


var useMounted = function useMounted() {
  var mounted = react_1.useRef(false);
  react_1.useEffect(function () {
    mounted.current = true;
    return function () {
      mounted.current = false;
    };
  }, []);
  return mounted;
};

function useRefState(initialState) {
  var blockIfUnmounted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var mounted = useMounted();

  var _react_1$useState = react_1.useState(initialState),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      reactState = _react_1$useState2[0],
      setReactState = _react_1$useState2[1];

  var state = react_1.useRef(reactState);
  var setState = react_1.useCallback(function (arg) {
    if (!mounted.current && blockIfUnmounted) return;
    state.current = typeof arg === 'function' ? arg(state.current) : arg;
    setReactState(state.current);
  }, []);
  return [state, setState];
}

exports.useRefState = useRefState;
exports["default"] = useRefState;

/***/ }),

/***/ "J4zp":
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__("wTVA");

var iterableToArrayLimit = __webpack_require__("m0LI");

var unsupportedIterableToArray = __webpack_require__("ZhPi");

var nonIterableRest = __webpack_require__("wkBT");

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;

/***/ }),

/***/ "LpkI":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller
// https://github.com/amiller-gh/currentScript-polyfill/blob/master/currentScript.js
// MIT license
(function (document) {
  var currentScript = 'currentScript'; // If browser needs currentScript polyfill, add get currentScript() to the document object

  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function get() {
        // IE 8-10 support script readyState
        // IE 11+ support stack trace
        try {
          throw new Error();
        } catch (err) {
          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i = 0,
              stackDetails = /.*at [^(]*\((.*):(.+):(.+)\)$/ig.exec(err.stack),
              scriptLocation = stackDetails && stackDetails[1] || false,
              line = stackDetails && stackDetails[2] || false,
              currentLocation = document.location.href.replace(document.location.hash, ''),
              pageSource,
              inlineScriptSourceRegExp,
              inlineScriptSource,
              scripts = document.getElementsByTagName('script'); // Live NodeList collection

          if (scriptLocation === currentLocation) {
            pageSource = document.documentElement.outerHTML;
            inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
            inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
          }

          for (; i < scripts.length; i++) {
            // If ready state is interactive, return the script tag
            if (scripts[i].readyState === 'interactive') {
              return scripts[i];
            } // If src matches, return the script tag


            if (scripts[i].src === scriptLocation) {
              return scripts[i];
            } // If inline source matches, return the script tag


            if (scriptLocation === currentLocation && scripts[i].innerHTML && scripts[i].innerHTML.trim() === inlineScriptSource) {
              return scripts[i];
            }
          } // If no match, return null


          return null;
        }
      }
    });
  }
})(document);

/***/ }),

/***/ "OJhj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __webpack_require__("cDcd");

exports.FetchContext = react_1.createContext({
  url: '',
  options: {},
  graphql: false // TODO: this will make it so useFetch(QUERY || MUTATION) will work

});
exports["default"] = exports.FetchContext;

/***/ }),

/***/ "QILm":
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__("8OQS");

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),

/***/ "UgvP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = __webpack_require__("l0/T");

var react_1 = __webpack_require__("cDcd");

var FetchContext_1 = __importDefault(__webpack_require__("OJhj"));

var defaults_1 = __importStar(__webpack_require__("DSXY"));

function useFetchArgs(urlOrPathOrOptionsOrOverwriteGlobalOptions, optionsOrOverwriteGlobalOrDeps, deps) {
  utils_1.invariant(!(utils_1.isObject(urlOrPathOrOptionsOrOverwriteGlobalOptions) && utils_1.isObject(optionsOrOverwriteGlobalOrDeps)), 'You cannot have a 2nd parameter of useFetch as object when your first argument is an object.');
  var context = react_1.useContext(FetchContext_1["default"]);
  var host = react_1.useMemo(function () {
    var maybeHost = urlOrPathOrOptionsOrOverwriteGlobalOptions;
    if (utils_1.isString(maybeHost) && maybeHost.includes('://')) return maybeHost;
    if (context.url) return context.url;
    return defaults_1["default"].host;
  }, [context.url, urlOrPathOrOptionsOrOverwriteGlobalOptions]);
  var path = react_1.useMemo(function () {
    var maybePath = urlOrPathOrOptionsOrOverwriteGlobalOptions;
    if (utils_1.isString(maybePath) && !maybePath.includes('://')) return maybePath;
  }, [urlOrPathOrOptionsOrOverwriteGlobalOptions]);
  var overwriteGlobalOptions = react_1.useMemo(function () {
    if (utils_1.isFunction(urlOrPathOrOptionsOrOverwriteGlobalOptions)) return urlOrPathOrOptionsOrOverwriteGlobalOptions;
    if (utils_1.isFunction(optionsOrOverwriteGlobalOrDeps)) return optionsOrOverwriteGlobalOrDeps;
  }, []);
  var options = react_1.useMemo(function () {
    var localOptions = {
      headers: {}
    };

    if (utils_1.isObject(urlOrPathOrOptionsOrOverwriteGlobalOptions)) {
      localOptions = urlOrPathOrOptionsOrOverwriteGlobalOptions;
    } else if (utils_1.isObject(optionsOrOverwriteGlobalOrDeps)) {
      localOptions = optionsOrOverwriteGlobalOrDeps;
    }

    var globalOptions = context.options;

    var finalOptions = __assign(__assign(__assign(__assign({}, defaults_1["default"]), globalOptions), localOptions), {
      headers: __assign(__assign(__assign({}, defaults_1["default"].headers), globalOptions.headers), localOptions.headers),
      interceptors: __assign(__assign(__assign({}, defaults_1["default"].interceptors), globalOptions.interceptors), localOptions.interceptors)
    });

    if (overwriteGlobalOptions) return overwriteGlobalOptions(finalOptions);
    return finalOptions;
  }, [urlOrPathOrOptionsOrOverwriteGlobalOptions, overwriteGlobalOptions, context.options]);
  var requestInit = react_1.useMemo(function () {
    return utils_1.pullOutRequestInit(options);
  }, [options]);
  var dependencies = react_1.useMemo(function () {
    if (Array.isArray(optionsOrOverwriteGlobalOrDeps)) return optionsOrOverwriteGlobalOrDeps;
    if (Array.isArray(deps)) return deps;
    return defaults_1["default"].dependencies;
  }, [optionsOrOverwriteGlobalOrDeps, deps]);
  var cacheLife = options.cacheLife,
      retries = options.retries,
      retryDelay = options.retryDelay,
      retryOn = options.retryOn;
  utils_1.invariant(Number.isInteger(cacheLife) && cacheLife >= 0, '`cacheLife` must be a number >= 0');
  utils_1.invariant(Number.isInteger(retries) && retries >= 0, '`retries` must be a number >= 0');
  utils_1.invariant(utils_1.isFunction(retryDelay) || Number.isInteger(retryDelay) && retryDelay >= 0, '`retryDelay` must be a positive number or a function returning a positive number.');
  var isValidRetryOn = utils_1.isFunction(retryOn) || Array.isArray(retryOn) && retryOn.every(utils_1.isPositiveNumber);
  utils_1.invariant(isValidRetryOn, '`retryOn` must be an array of positive numbers or a function returning a boolean.');
  var loading = options.loading || Array.isArray(dependencies);
  var interceptors = react_1.useMemo(function () {
    var _final = {};
    if ('request' in options.interceptors) _final.request = options.interceptors.request;
    if ('response' in options.interceptors) _final.response = options.interceptors.response;
    return _final;
  }, [options]);
  var customOptions = react_1.useMemo(function () {
    var customOptionKeys = Object.keys(defaults_1.useFetchArgsDefaults.customOptions); // Array<keyof CustomOptions>

    var customOptions = customOptionKeys.reduce(function (opts, key) {
      opts[key] = options[key];
      return opts;
    }, {});
    return __assign(__assign({}, customOptions), {
      interceptors: interceptors,
      loading: loading
    });
  }, [interceptors, loading]);
  return {
    host: host,
    path: path,
    customOptions: customOptions,
    requestInit: requestInit,
    dependencies: dependencies
  };
}

exports["default"] = useFetchArgs;

/***/ }),

/***/ "WkPL":
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;

/***/ }),

/***/ "X+Cm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var use_ssr_1 = __importDefault(__webpack_require__("gHsK"));

var utils_1 = __webpack_require__("l0/T");

var types_1 = __webpack_require__("c/c1");

var localStorage_1 = __importDefault(__webpack_require__("mSPe"));

var memoryStorage_1 = __importDefault(__webpack_require__("0Uja"));

var NETWORK_ONLY = types_1.CachePolicies.NETWORK_ONLY,
    NO_CACHE = types_1.CachePolicies.NO_CACHE;

var useCache = function useCache(_a) {
  var persist = _a.persist,
      cacheLife = _a.cacheLife,
      cachePolicy = _a.cachePolicy;

  var _b = use_ssr_1["default"](),
      isNative = _b.isNative,
      isServer = _b.isServer;

  utils_1.invariant(!(isServer && persist), 'There is no persistent storage on the Server currently! 🙅‍♂️');
  utils_1.invariant(!(isNative && persist), 'React Native support for persistent cache is not yet implemented. 🙅‍♂️');
  utils_1.invariant(!(persist && [NO_CACHE, NETWORK_ONLY].includes(cachePolicy)), "You cannot use option 'persist' with cachePolicy: " + cachePolicy + " \uD83D\uDE45\u200D\u2642\uFE0F"); // right now we're not worrying about react-native

  if (persist) return localStorage_1["default"]({
    cacheLife: cacheLife || 24 * 3600000
  });
  return memoryStorage_1["default"]({
    cacheLife: cacheLife
  });
};

exports["default"] = useCache;

/***/ }),

/***/ "YuTi":
/***/ (function(module, exports) {

module.exports = function (module) {
  if (!module.webpackPolyfill) {
    module.deprecate = function () {};

    module.paths = []; // module.parent = undefined by default

    if (!module.children) module.children = [];
    Object.defineProperty(module, "loaded", {
      enumerable: true,
      get: function get() {
        return module.l;
      }
    });
    Object.defineProperty(module, "id", {
      enumerable: true,
      get: function get() {
        return module.i;
      }
    });
    module.webpackPolyfill = 1;
  }

  return module;
};

/***/ }),

/***/ "ZhPi":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__("WkPL");

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;

/***/ }),

/***/ "c/c1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var HTTPMethod;

(function (HTTPMethod) {
  HTTPMethod["DELETE"] = "DELETE";
  HTTPMethod["GET"] = "GET";
  HTTPMethod["HEAD"] = "HEAD";
  HTTPMethod["OPTIONS"] = "OPTIONS";
  HTTPMethod["PATCH"] = "PATCH";
  HTTPMethod["POST"] = "POST";
  HTTPMethod["PUT"] = "PUT";
})(HTTPMethod = exports.HTTPMethod || (exports.HTTPMethod = {})); // https://www.apollographql.com/docs/react/api/react-apollo/#optionsfetchpolicy


var CachePolicies;

(function (CachePolicies) {
  /**
   * This is the default value where we always try reading data
   * from your cache first. If all the data needed to fulfill
   * your query is in the cache then that data will be returned.
   * useFetch will only fetch from the network if a cached result
   * is not available. This fetch policy aims to minimize the number
   * of network requests sent when rendering your component.
   */
  CachePolicies["CACHE_FIRST"] = "cache-first";
  /**
   * This fetch policy will have useFetch first trying to read data
   * from your cache. If all the data needed to fulfill your query
   * is in the cache then that data will be returned. However,
   * regardless of whether or not the full data is in your cache
   * this fetchPolicy will always execute query with the network
   * interface unlike cache-first which will only execute your query
   * if the query data is not in your cache. This fetch policy optimizes
   * for users getting a quick response while also trying to keep
   * cached data consistent with your server data at the cost of extra
   * network requests.
   */

  CachePolicies["CACHE_AND_NETWORK"] = "cache-and-network";
  /**
   * This fetch policy will never return your initial data from the
   * cache. Instead it will always make a request using your network
   * interface to the server. This fetch policy optimizes for data
   * consistency with the server, but at the cost of an instant response
   * to the user when one is available.
   */

  CachePolicies["NETWORK_ONLY"] = "network-only";
  /**
   * This fetch policy will never execute a query using your network
   * interface. Instead it will always try reading from the cache. If the
   * data for your query does not exist in the cache then an error will be
   * thrown. This fetch policy allows you to only interact with data in
   * your local client cache without making any network requests which
   * keeps your component fast, but means your local data might not be
   * consistent with what is on the server.
   */

  CachePolicies["CACHE_ONLY"] = "cache-only";
  /**
   * This fetch policy will never return your initial data from the cache.
   * Instead it will always make a request using your network interface to
   * the server. Unlike the network-only policy, it also will not write
   * any data to the cache after the query completes.
   */

  CachePolicies["NO_CACHE"] = "no-cache";
  CachePolicies["EXACT_CACHE_AND_NETWORK"] = "exact-cache-and-network";
})(CachePolicies = exports.CachePolicies || (exports.CachePolicies = {}));

/***/ }),

/***/ "cDcd":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_cDcd__;

/***/ }),

/***/ "cDf5":
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),

/***/ "cPIZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function __export(m) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var useFetch_1 = __webpack_require__("zVFb");

exports["default"] = useFetch_1["default"];

__export(__webpack_require__("zVFb"));

__export(__webpack_require__("Bapv"));

__export(__webpack_require__("99zy"));

__export(__webpack_require__("xe5I"));

__export(__webpack_require__("OJhj"));

__export(__webpack_require__("c/c1"));

/***/ }),

/***/ "gHsK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Device;

(function (Device) {
  Device["Browser"] = "browser";
  Device["Server"] = "server";
  Device["Native"] = "native";
})(Device = exports.Device || (exports.Device = {}));

var Browser = Device.Browser,
    Server = Device.Server,
    Native = Device.Native;
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var canUseNative = typeof navigator != 'undefined' && navigator.product == 'ReactNative';
var device = canUseNative ? Native : canUseDOM ? Browser : Server;
var SSRObject = {
  isBrowser: device === Browser,
  isServer: device === Server,
  isNative: device === Native,
  device: device,
  canUseWorkers: typeof Worker !== 'undefined',
  canUseEventListeners: device === Browser && !!window.addEventListener,
  canUseViewport: device === Browser && !!window.screen
}; // TODO: instead of this, do a polyfill for `Object.assign` https://www.npmjs.com/package/es6-object-assign

var assign = function assign() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  return args.reduce(function (acc, obj) {
    return __assign(__assign({}, acc), obj);
  }, {});
};

var values = function values(obj) {
  return Object.keys(obj).map(function (key) {
    return obj[key];
  });
};

var toArrayObject = function toArrayObject() {
  return assign((values(SSRObject), SSRObject));
};

var useSSRObject = toArrayObject();

exports.weAreServer = function () {
  SSRObject.isServer = true;
  useSSRObject = toArrayObject();
};

exports.useSSR = function () {
  return useSSRObject;
};

exports["default"] = exports.useSSR;

/***/ }),

/***/ "l0/T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __webpack_require__("cDcd");

var use_ssr_1 = __importDefault(__webpack_require__("gHsK"));
/**
 * Used for error checking. If the condition is false, throw an error
 */


function invariant(condition, format, a, b, c, d, e, f) {
  if (a === void 0) {
    a = '';
  }

  if (b === void 0) {
    b = '';
  }

  if (c === void 0) {
    c = '';
  }

  if (d === void 0) {
    d = '';
  }

  if (e === void 0) {
    e = '';
  }

  if (f === void 0) {
    f = '';
  }

  if (false) {}

  if (!condition) {
    var error = void 0;

    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args_1 = [a, b, c, d, e, f];
      var argIndex_1 = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args_1[argIndex_1++];
      }));
      error.name = 'Invariant Violation';
    }

    throw error;
  }
}

exports.invariant = invariant;

exports.useExampleURL = function () {
  var isBrowser = use_ssr_1["default"]().isBrowser;
  return react_1.useMemo(function () {
    return isBrowser ? window.location.origin : 'https://example.com';
  }, [isBrowser]);
};

function useURLRequiredInvariant(condition, method, optionalMessage) {
  var exampleURL = exports.useExampleURL();
  react_1.useEffect(function () {
    invariant(condition, method + " requires a URL to be set as the 1st argument,\n\n      unless you wrap your app like:\n\n      <Provider url=\"" + exampleURL + "\"><App /></Provider>\n\n      " + optionalMessage);
  }, [condition, exampleURL, method, optionalMessage]);
}

exports.useURLRequiredInvariant = useURLRequiredInvariant;

exports.isString = function (x) {
  return typeof x === 'string';
}; // eslint-disable-line

/**
 * Determines if the given param is an object. {}
 * @param obj
 */


exports.isObject = function (obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}; // eslint-disable-line

/**
 * Determines if the given param is an object that can be used as a request body.
 * Returns true for native objects or arrays.
 * @param obj
 */


exports.isBodyObject = function (obj) {
  return exports.isObject(obj) || Array.isArray(obj);
};

exports.isFunction = function (v) {
  return typeof v === 'function';
};

exports.isNumber = function (v) {
  return Object.prototype.toString.call(v) === '[object Number]';
}; // const requestFields = Object.getOwnPropertyNames(Object.getPrototypeOf(new Request('')))
// const responseFields = Object.getOwnPropertyNames(Object.getPrototypeOf(new Response()))
// export const customResponseFields = [...responseFields, 'data']
// TODO: come back and fix the "anys" in this http://bit.ly/2Lm3OLi

/**
 * Makes an object that will match the standards of a normal fetch's options
 * aka: pulls out all useFetch's special options like "onMount"
 */


exports.pullOutRequestInit = function (options) {
  if (!options) return {};
  var requestInitFields = ['body', 'cache', 'credentials', 'headers', 'integrity', 'keepalive', 'method', 'mode', 'redirect', 'referrer', 'referrerPolicy', 'signal', 'window'];
  return requestInitFields.reduce(function (acc, key) {
    if (key in options) acc[key] = options[key];
    return acc;
  }, {});
};

exports.isEmpty = function (x) {
  return x === undefined || x === null;
};

var Device;

(function (Device) {
  Device["Browser"] = "browser";
  Device["Server"] = "server";
  Device["Native"] = "native";
})(Device = exports.Device || (exports.Device = {}));

var Browser = Device.Browser,
    Server = Device.Server,
    Native = Device.Native;
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var canUseNative = typeof navigator !== 'undefined' && navigator.product === 'ReactNative';
var device = canUseNative ? Native : canUseDOM ? Browser : Server;
exports.isBrowser = device === Browser;
exports.isServer = device === Server;
exports.isNative = device === Native;

exports.tryGetData = function (res, defaultData, responseType) {
  return __awaiter(void 0, void 0, void 0, function () {
    var types, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (typeof res === 'undefined') throw Error('Response cannot be undefined... 😵');
          if (typeof responseType === 'undefined') throw Error('responseType cannot be undefined... 😵');
          types = Array.isArray(responseType) ? responseType : [responseType];
          if (types[0] == null) throw Error('could not parse data from response 😵');
          return [4
          /*yield*/
          , tryRetry(res, types)];

        case 1:
          data = _a.sent();
          return [2
          /*return*/
          , !exports.isEmpty(defaultData) && exports.isEmpty(data) ? defaultData : data];
      }
    });
  });
};

var tryRetry = function tryRetry(res, types, i) {
  if (i === void 0) {
    i = 0;
  }

  return __awaiter(void 0, void 0, void 0, function () {
    var error_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);

          return [4
          /*yield*/
          , res.clone()[types[i]]()];

        case 1:
          return [2
          /*return*/
          , _a.sent()];

        case 2:
          error_1 = _a.sent();
          if (types.length - 1 === i) throw error_1;
          return [2
          /*return*/
          , tryRetry(res.clone(), types, ++i)];

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
};

exports.responseFields = ['headers', 'ok', 'redirected', 'trailer', 'status', 'statusText', 'type', 'url', 'body', 'bodyUsed', 'data'];
exports.responseMethods = ['clone', 'arrayBuffer', 'blob', 'formData', 'json', 'text'];
exports.responseKeys = __spreadArrays(exports.responseFields, exports.responseMethods);

exports.toResponseObject = function (res, data) {
  return Object.defineProperties({}, exports.responseKeys.reduce(function (acc, field) {
    if (exports.responseFields.includes(field)) {
      acc[field] = {
        get: function get() {
          var response = res instanceof Response ? res : res && res.current;
          if (!response) return;
          if (field === 'data') return data.current;
          var clonedResponse = 'clone' in response ? response.clone() : {};
          return clonedResponse[field];
        },
        enumerable: true
      };
    } else if (exports.responseMethods.includes(field)) {
      acc[field] = {
        value: function value() {
          var response = res instanceof Response ? res : res && res.current;
          if (!response) return;
          var clonedResponse = 'clone' in response ? response.clone() : {};
          return clonedResponse[field]();
        },
        enumerable: true
      };
    }

    return acc;
  }, {}));
};

exports.emptyCustomResponse = exports.toResponseObject(); // TODO: switch this to .reduce()

var headersAsObject = function headersAsObject(headers) {
  var obj = {};
  headers.forEach(function (value, key) {
    obj[key] = value;
  });
  return obj;
};

exports.serializeResponse = function (response) {
  return __awaiter(void 0, void 0, void 0, function () {
    var body, status, statusText, headers;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , response.text()];

        case 1:
          body = _a.sent();
          status = response.status, statusText = response.statusText;
          headers = headersAsObject(response.headers);
          return [2
          /*return*/
          , {
            body: body,
            status: status,
            statusText: statusText,
            headers: headers
          }];
      }
    });
  });
};

function useDeepCompareMemoize(value) {
  var ref = react_1.useRef();
  if (JSON.stringify(value) !== JSON.stringify(ref.current)) ref.current = value;
  return ref.current;
}

exports.useDeepCallback = function (cb, deps) {
  return react_1.useCallback(cb, useDeepCompareMemoize(deps));
};

exports.sleep = function (ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};

exports.isPositiveNumber = function (n) {
  return Number.isInteger(n) && n > 0;
};

exports.makeError = function (name, message) {
  var error = new Error(message);
  error.name = name + '';
  return error;
};
/**
 * Determines if we need to add a slash to front
 * of a path, and adds it if we do.
 * Cases:
 * (path = '', url = '' || null | undefined) => ''
 * (path = '?foo=bar', url = 'a.com')        => '?foo=bar'
 * (path = '?foo=bar', url = 'a.com/')       => '?foo=bar'
 * (path = 'foo', url = 'a.com')             => '/foo'
 * (path = 'foo', url = 'a.com/')            => 'foo'
 * (path = '/foo', url = 'a.com')            => '/foo'
 * (path = '/foo', url = 'a.com/')           => 'foo'
 * (path = '?foo=bar')                       => '?foo=bar'
 * (path = 'foo')                            => '/foo'
 * (path = '/foo')                           => '/foo'
 */


exports.addSlash = function (input, url) {
  if (!input) return '';

  if (!url) {
    if (input.startsWith('?') || input.startsWith('/')) return input;
    return "/" + input;
  }

  if (url.endsWith('/') && input.startsWith('/')) return input.substr(1);
  if (!url.endsWith('/') && !input.startsWith('/') && !input.startsWith('?')) return "/" + input;
  return input;
};

/***/ }),

/***/ "lSNA":
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),

/***/ "ls82":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var _typeof = __webpack_require__("cDf5");

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var runtime = function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.

  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.

    generator._invoke = makeInvokeMethod(innerFn, self, context);
    return generator;
  }

  exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.

  var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.


  var IteratorPrototype = {};

  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

  if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction"; // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      prototype[method] = function (arg) {
        return this._invoke(method, arg);
      };
    });
  }

  exports.isGeneratorFunction = function (genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
    // do is to check its .name property.
    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
  };

  exports.mark = function (genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;

      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }

    genFun.prototype = Object.create(Gp);
    return genFun;
  }; // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.


  exports.awrap = function (arg) {
    return {
      __await: arg
    };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;

        if (value && _typeof(value) === "object" && hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function (value) {
            invoke("next", value, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function (unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function (error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = // If enqueue has been called before, then we want to wait until
      // all previous Promises have been resolved before calling invoke,
      // so that results are always delivered in the correct order. If
      // enqueue has not been called before, then it is important to
      // call invoke immediately, without waiting on a callback to fire,
      // so that the async generator function has the opportunity to do
      // any necessary setup in a predictable way. This predictability
      // is why the Promise constructor synchronously invokes its
      // executor callback, and why async functions synchronously
      // execute code before the first await. Since we implement simple
      // async functions in terms of async generators, it is especially
      // important to get this right, even though it requires care.
      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
      // invocations of the iterator.
      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    } // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).


    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);

  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };

  exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.

  exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
    : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;
    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        } // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;

        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);

          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;
        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);
        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;
        var record = tryCatch(innerFn, self, context);

        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done ? GenStateCompleted : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };
        } else if (record.type === "throw") {
          state = GenStateCompleted; // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.

          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  } // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.


  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (!info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

      context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.

      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }
    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    } // The delegate iterator is finished, so forget it and continue with
    // the outer generator.


    context.delegate = null;
    return ContinueSentinel;
  } // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.


  defineIteratorMethods(Gp);
  Gp[toStringTagSymbol] = "Generator"; // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.

  Gp[iteratorSymbol] = function () {
    return this;
  };

  Gp.toString = function () {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{
      tryLoc: "root"
    }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function (object) {
    var keys = [];

    for (var key in object) {
      keys.push(key);
    }

    keys.reverse(); // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.

    return function next() {
      while (keys.length) {
        var key = keys.pop();

        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      } // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.


      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];

      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;
          return next;
        };

        return next.next = next;
      }
    } // Return an iterator with no values.


    return {
      next: doneResult
    };
  }

  exports.values = values;

  function doneResult() {
    return {
      value: undefined,
      done: true
    };
  }

  Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      this.prev = 0;
      this.next = 0; // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.

      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;
      this.method = "next";
      this.arg = undefined;
      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },
    stop: function stop() {
      this.done = true;
      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;

      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;

      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }
          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" || record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      } // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.


      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  }; // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.

  return exports;
}( // If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
( false ? undefined : _typeof(module)) === "object" ? module.exports : {});

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("YuTi")(module)))

/***/ }),

/***/ "m0LI":
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;

/***/ }),

/***/ "mSPe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = __webpack_require__("l0/T");

var cacheName = 'useHTTPcache';

var getCache = function getCache() {
  try {
    return JSON.parse(localStorage.getItem(cacheName) || '{}');
  } catch (err) {
    localStorage.removeItem(cacheName);
    return {};
  }
};

var getLocalStorage = function getLocalStorage(_a) {
  var cacheLife = _a.cacheLife;

  var remove = function remove() {
    var responseIDs = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      responseIDs[_i] = arguments[_i];
    }

    return __awaiter(void 0, void 0, void 0, function () {
      var cache;
      return __generator(this, function (_a) {
        cache = getCache();
        responseIDs.forEach(function (id) {
          return delete cache[id];
        });
        localStorage.setItem(cacheName, JSON.stringify(cache));
        return [2
        /*return*/
        ];
      });
    });
  };

  var isExpired = function isExpired(responseID) {
    var cache = getCache();

    var _a = cache[responseID] || {},
        expiration = _a.expiration,
        response = _a.response;

    var expired = expiration > 0 && expiration < Date.now();
    if (expired) remove(responseID);
    return expired || !response;
  };

  var has = function has(responseID) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , !isExpired(responseID)];
      });
    });
  };

  var get = function get(responseID) {
    return __awaiter(void 0, void 0, void 0, function () {
      var cache, _a, body, headers, status, statusText;

      return __generator(this, function (_b) {
        if (isExpired(responseID)) return [2
        /*return*/
        ];
        cache = getCache();
        _a = cache[responseID].response, body = _a.body, headers = _a.headers, status = _a.status, statusText = _a.statusText;
        return [2
        /*return*/
        , new Response(body, {
          status: status,
          statusText: statusText,
          headers: new Headers(headers || {})
        })];
      });
    });
  };

  var set = function set(responseID, response) {
    return __awaiter(void 0, void 0, void 0, function () {
      var cache, _a, _b, _c;

      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            cache = getCache();
            _a = cache;
            _b = responseID;
            _c = {};
            return [4
            /*yield*/
            , utils_1.serializeResponse(response)];

          case 1:
            _a[_b] = (_c.response = _d.sent(), _c.expiration = Date.now() + cacheLife, _c);
            localStorage.setItem(cacheName, JSON.stringify(cache));
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  var clear = function clear() {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        localStorage.setItem(cacheName, JSON.stringify({}));
        return [2
        /*return*/
        ];
      });
    });
  };

  return Object.defineProperties(getCache(), {
    get: {
      value: get,
      writable: false
    },
    set: {
      value: set,
      writable: false
    },
    has: {
      value: has,
      writable: false
    },
    "delete": {
      value: remove,
      writable: false
    },
    clear: {
      value: clear,
      writable: false
    }
  });
};

exports["default"] = getLocalStorage;

/***/ }),

/***/ "o0o1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("ls82");

/***/ }),

/***/ "pVnL":
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),

/***/ "wTVA":
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;

/***/ }),

/***/ "wkBT":
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest;

/***/ }),

/***/ "xe5I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(__webpack_require__("cDcd"));

var use_ssr_1 = __importDefault(__webpack_require__("gHsK"));

var FetchContext_1 = __importDefault(__webpack_require__("OJhj"));

exports.Provider = function (_a) {
  var url = _a.url,
      options = _a.options,
      _b = _a.graphql,
      graphql = _b === void 0 ? false : _b,
      children = _a.children;
  var isBrowser = use_ssr_1["default"]().isBrowser;
  var defaults = react_1.useMemo(function () {
    return {
      url: url || (isBrowser ? window.location.origin : ''),
      options: options || {},
      graphql: graphql // TODO: this will make it so useFetch(QUERY || MUTATION) will work

    };
  }, [options, graphql, isBrowser, url]);
  return react_1["default"].createElement(FetchContext_1["default"].Provider, {
    value: defaults
  }, children);
};

/***/ }),

/***/ "yXPU":
/***/ (function(module, exports) {

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

module.exports = _asyncToGenerator;

/***/ }),

/***/ "zVFb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __webpack_require__("cDcd");

var use_ssr_1 = __importDefault(__webpack_require__("gHsK"));

var urs_1 = __importDefault(__webpack_require__("GoE2"));

var types_1 = __webpack_require__("c/c1");

var useFetchArgs_1 = __importDefault(__webpack_require__("UgvP"));

var doFetchArgs_1 = __importDefault(__webpack_require__("+4Q3"));

var utils_1 = __webpack_require__("l0/T");

var useCache_1 = __importDefault(__webpack_require__("X+Cm"));

var CACHE_FIRST = types_1.CachePolicies.CACHE_FIRST;

function useFetch() {
  var _this = this;

  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  var _a = useFetchArgs_1["default"].apply(void 0, args),
      host = _a.host,
      path = _a.path,
      customOptions = _a.customOptions,
      requestInit = _a.requestInit,
      dependencies = _a.dependencies;

  var cacheLife = customOptions.cacheLife,
      cachePolicy = customOptions.cachePolicy,
      // 'cache-first' by default
  interceptors = customOptions.interceptors,
      onAbort = customOptions.onAbort,
      onError = customOptions.onError,
      onNewData = customOptions.onNewData,
      onTimeout = customOptions.onTimeout,
      perPage = customOptions.perPage,
      persist = customOptions.persist,
      responseType = customOptions.responseType,
      retries = customOptions.retries,
      retryDelay = customOptions.retryDelay,
      retryOn = customOptions.retryOn,
      suspense = customOptions.suspense,
      timeout = customOptions.timeout,
      defaults = __rest(customOptions, ["cacheLife", "cachePolicy", "interceptors", "onAbort", "onError", "onNewData", "onTimeout", "perPage", "persist", "responseType", "retries", "retryDelay", "retryOn", "suspense", "timeout"]);

  var cache = useCache_1["default"]({
    persist: persist,
    cacheLife: cacheLife,
    cachePolicy: cachePolicy
  });
  var isServer = use_ssr_1["default"]().isServer;
  var controller = react_1.useRef();
  var res = react_1.useRef({});
  var data = react_1.useRef(defaults.data);
  var timedout = react_1.useRef(false);
  var attempt = react_1.useRef(0);
  var error = react_1.useRef();
  var hasMore = react_1.useRef(true);
  var suspenseStatus = react_1.useRef('pending');
  var suspender = react_1.useRef();
  var mounted = react_1.useRef(false);

  var _b = urs_1["default"](defaults.loading),
      loading = _b[0],
      setLoading = _b[1];

  var forceUpdate = react_1.useReducer(function () {
    return {};
  }, [])[1];
  var makeFetch = utils_1.useDeepCallback(function (method) {
    var doFetch = function doFetch(routeOrBody, body) {
      return __awaiter(_this, void 0, void 0, function () {
        var theController, _a, url, options, response, timer, newData, newRes, _b, _c, opts, shouldRetry, _d, _e, theData, err_1, opts, shouldRetry, _f, _g, theData;

        return __generator(this, function (_h) {
          switch (_h.label) {
            case 0:
              if (isServer) return [2
              /*return*/
              ]; // for now, we don't do anything on the server

              controller.current = new AbortController();
              controller.current.signal.onabort = onAbort;
              theController = controller.current;
              return [4
              /*yield*/
              , doFetchArgs_1["default"](requestInit, method, theController, cacheLife, cache, host, path, routeOrBody, body, interceptors.request)];

            case 1:
              _a = _h.sent(), url = _a.url, options = _a.options, response = _a.response;
              error.current = undefined; // don't perform the request if there is no more data to fetch (pagination)

              if (perPage > 0 && !hasMore.current && !error.current) return [2
              /*return*/
              , data.current];
              if (!suspense) setLoading(true);
              timer = timeout && setTimeout(function () {
                timedout.current = true;
                theController.abort();
                if (onTimeout) onTimeout();
              }, timeout);
              _h.label = 2;

            case 2:
              _h.trys.push([2, 17, 23, 24]);

              if (!(response.isCached && cachePolicy === CACHE_FIRST)) return [3
              /*break*/
              , 3];
              newRes = response.cached;
              return [3
              /*break*/
              , 5];

            case 3:
              return [4
              /*yield*/
              , fetch(url, options)];

            case 4:
              newRes = _h.sent();
              _h.label = 5;

            case 5:
              res.current = newRes.clone();
              return [4
              /*yield*/
              , utils_1.tryGetData(newRes, defaults.data, responseType)];

            case 6:
              newData = _h.sent();
              res.current.data = onNewData(data.current, newData);
              _b = res;
              if (!interceptors.response) return [3
              /*break*/
              , 8];
              return [4
              /*yield*/
              , interceptors.response({
                response: res.current
              })];

            case 7:
              _c = _h.sent();
              return [3
              /*break*/
              , 9];

            case 8:
              _c = res.current;
              _h.label = 9;

            case 9:
              _b.current = _c;
              utils_1.invariant('data' in res.current, 'You must have `data` field on the Response returned from your `interceptors.response`');
              data.current = res.current.data;
              opts = {
                attempt: attempt.current,
                response: newRes
              }; // if we just have `retries` set with NO `retryOn` then
              // automatically retry on fail until attempts run out

              _d = !utils_1.isFunction(retryOn) && Array.isArray(retryOn) && retryOn.length < 1 && (newRes === null || newRes === void 0 ? void 0 : newRes.ok) === false // otherwise only retry when is specified
              || Array.isArray(retryOn) && retryOn.includes(newRes.status);
              if (_d) // if we just have `retries` set with NO `retryOn` then
                // automatically retry on fail until attempts run out
                return [3
                /*break*/
                , 12];
              _e = utils_1.isFunction(retryOn);
              if (!_e) return [3
              /*break*/
              , 11];
              return [4
              /*yield*/
              , retryOn(opts)];

            case 10:
              _e = _h.sent();
              _h.label = 11;

            case 11:
              _d = _e;
              _h.label = 12;

            case 12:
              shouldRetry = _d && retries > 0 && retries > attempt.current;
              if (!shouldRetry) return [3
              /*break*/
              , 14];
              return [4
              /*yield*/
              , retry(opts, routeOrBody, body)];

            case 13:
              theData = _h.sent();
              return [2
              /*return*/
              , theData];

            case 14:
              if (!(cachePolicy === CACHE_FIRST)) return [3
              /*break*/
              , 16];
              return [4
              /*yield*/
              , cache.set(response.id, newRes.clone())];

            case 15:
              _h.sent();

              _h.label = 16;

            case 16:
              if (Array.isArray(data.current) && !!(data.current.length % perPage)) hasMore.current = false;
              return [3
              /*break*/
              , 24];

            case 17:
              err_1 = _h.sent();
              if (attempt.current >= retries && timedout.current) error.current = utils_1.makeError('AbortError', 'Timeout Error');
              opts = {
                attempt: attempt.current,
                error: err_1
              }; // if we just have `retries` set with NO `retryOn` then
              // automatically retry on fail until attempts run out

              _f = !utils_1.isFunction(retryOn) && Array.isArray(retryOn) && retryOn.length < 1;
              if (_f) // if we just have `retries` set with NO `retryOn` then
                // automatically retry on fail until attempts run out
                return [3
                /*break*/
                , 20];
              _g = utils_1.isFunction(retryOn);
              if (!_g) return [3
              /*break*/
              , 19];
              return [4
              /*yield*/
              , retryOn(opts)];

            case 18:
              _g = _h.sent();
              _h.label = 19;

            case 19:
              _f = _g;
              _h.label = 20;

            case 20:
              shouldRetry = _f && retries > 0 && retries > attempt.current;
              if (!shouldRetry) return [3
              /*break*/
              , 22];
              return [4
              /*yield*/
              , retry(opts, routeOrBody, body)];

            case 21:
              theData = _h.sent();
              return [2
              /*return*/
              , theData];

            case 22:
              if (err_1.name !== 'AbortError') error.current = utils_1.makeError(err_1.name, err_1.message);
              return [3
              /*break*/
              , 24];

            case 23:
              timedout.current = false;
              if (timer) clearTimeout(timer);
              controller.current = undefined;
              return [7
              /*endfinally*/
              ];

            case 24:
              if (newRes && !newRes.ok && !error.current) error.current = utils_1.makeError(newRes.status, newRes.statusText);
              if (!suspense) setLoading(false);
              if (attempt.current === retries) attempt.current = 0;
              if (error.current) onError({
                error: error.current
              });
              return [2
              /*return*/
              , data.current];
          }
        });
      });
    }; // end of doFetch()


    var retry = function retry(opts, routeOrBody, body) {
      return __awaiter(_this, void 0, void 0, function () {
        var delay, d;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              delay = utils_1.isFunction(retryDelay) ? retryDelay(opts) : retryDelay;

              if (!(Number.isInteger(delay) && delay >= 0)) {
                console.error('retryDelay must be a number >= 0! If you\'re using it as a function, it must also return a number >= 0.');
              }

              attempt.current++;
              if (!delay) return [3
              /*break*/
              , 2];
              return [4
              /*yield*/
              , utils_1.sleep(delay)];

            case 1:
              _a.sent();

              _a.label = 2;

            case 2:
              return [4
              /*yield*/
              , doFetch(routeOrBody, body)];

            case 3:
              d = _a.sent();
              return [2
              /*return*/
              , d];
          }
        });
      });
    };

    if (suspense) {
      return function () {
        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }

        return __awaiter(_this, void 0, void 0, function () {
          var newData;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                suspender.current = doFetch.apply(void 0, args).then(function (newData) {
                  suspenseStatus.current = 'success';
                  return newData;
                }, function () {
                  suspenseStatus.current = 'error';
                });
                forceUpdate();
                return [4
                /*yield*/
                , suspender.current];

              case 1:
                newData = _a.sent();
                return [2
                /*return*/
                , newData];
            }
          });
        });
      };
    }

    return doFetch;
  }, [isServer, onAbort, requestInit, host, path, interceptors, cachePolicy, perPage, timeout, persist, cacheLife, onTimeout, defaults.data, onNewData, forceUpdate, suspense]);
  var post = react_1.useCallback(makeFetch(types_1.HTTPMethod.POST), [makeFetch]);
  var del = react_1.useCallback(makeFetch(types_1.HTTPMethod.DELETE), [makeFetch]);
  var request = react_1.useMemo(function () {
    return Object.defineProperties({
      get: makeFetch(types_1.HTTPMethod.GET),
      post: post,
      patch: makeFetch(types_1.HTTPMethod.PATCH),
      put: makeFetch(types_1.HTTPMethod.PUT),
      del: del,
      "delete": del,
      abort: function abort() {
        return controller.current && controller.current.abort();
      },
      query: function query(_query, variables) {
        return post({
          query: _query,
          variables: variables
        });
      },
      mutate: function mutate(mutation, variables) {
        return post({
          mutation: mutation,
          variables: variables
        });
      },
      cache: cache
    }, {
      loading: {
        get: function get() {
          return loading.current;
        }
      },
      error: {
        get: function get() {
          return error.current;
        }
      },
      data: {
        get: function get() {
          return data.current;
        }
      }
    });
  }, [makeFetch]);
  var response = react_1.useMemo(function () {
    return utils_1.toResponseObject(res, data);
  }, []); // onMount/onUpdate

  react_1.useEffect(function () {
    mounted.current = true;

    if (Array.isArray(dependencies)) {
      var methodName = requestInit.method || types_1.HTTPMethod.GET;
      var methodLower = methodName.toLowerCase();
      var req = request[methodLower];
      req();
    }

    return function () {
      return mounted.current = false;
    };
  }, dependencies); // Cancel any running request when unmounting to avoid updating state after component has unmounted
  // This can happen if a request's promise resolves after component unmounts

  react_1.useEffect(function () {
    return request.abort;
  }, []);

  if (suspense && suspender.current) {
    if (isServer) throw new Error('Suspense on server side is not yet supported! 🙅‍♂️');

    switch (suspenseStatus.current) {
      case 'pending':
        throw suspender.current;

      case 'error':
        throw error.current;
    }
  }

  return Object.assign([request, response, loading.current, error.current], __assign(__assign({
    request: request,
    response: response
  }, request), {
    loading: loading.current,
    data: data.current,
    error: error.current
  }));
}

exports.useFetch = useFetch;
exports["default"] = useFetch;

/***/ })

/******/ });
});
//# sourceMappingURL=api.js.map